module.exports = __webpack_public_path__ + "static/img/aboutShuoTuoTop.14c89b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutShuoTuoTop.png
// module id = rZC2
// module chunks = 2